const keyMirror = require("keymirror");

export const PersonalInfoConstant = keyMirror({
  FETCH_PERSONAL_INFO: undefined,
  GET_PRODUCT_VARIANTS:undefined,
});
